import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { Employee } from '../appointments/backendClasses';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  
  constructor(private _service: LoginService, private _router: Router) {
    if(localStorage.getItem('token')){
      this._router.navigate(['pages/dashboard']);
    }
  }

  email: string;
  password: string;
  errorMessage: string;

  login(){
    this._service.login({
      employee: {
        email : this.email,
        password : this.password
      }
    }).subscribe(res=>{
      
      if(res.message){
        this.errorMessage = res.message;
      }

      if(res.token){
        localStorage.setItem('token', res.token);
        this._service.getTokenData().subscribe(res=>{
          console.log(res);
          localStorage.setItem('user', JSON.stringify(res));
          switch(res.role){
            case "Admin":
            case "Manager":
            case "Employee":
              this._router.navigate(['pages/dashboard']);
              break;
            case "Doctor":
              this._router.navigate(['pages/archivos']);
              break;
          }
        });
      }

    });
  }

}
